import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import {getCurrentLanguage} from "../helpers/functions";

const en_common = require("./en/common.json");
const en_project = require("./en/project.json");
const en_channel = require("./en/channel.json");
const en_connectorHandler = require("./en/connectorHandler.json");
const en_connector = require("./en/connector.json");
const en_counter = require("./en/counter.json");
const en_target = require("./en/target.json");
const en_targetStatus = require("./en/targetStatus.json");
const en_targetType = require("./en/targetType.json");
const en_validator = require("./en/validator.json");
const en_user = require("./en/user.json");
const en_notification = require("./en/notification.json");
const en_notificationStatus = require("./en/notificationStatus.json");
const en_wizard = require("./en/wizard.json");
const en_search = require("./en/search.json");
const en_peerActivity = require("./en/peerActivity.json");
const en_comment = require("./en/comment.json");
const en_stat = require("./en/stat.json");
const en_peerActivityStatus = require("./en/peerActivityStatus.json");
const en_eventType = require("./en/eventType.json");
const en_peerActivityType = require("./en/peerActivityType.json");
const en_peerActivityMode = require("./en/peerActivityMode.json");
const en_variantGroup = require("./en/variantGroup.json");
const en_recurrentPeriod = require("./en/recurrentPeriod.json");
const en_template = require("./en/template.json");
const en_quickAnswer = require("./en/quickAnswer.json");
const en_statCounter = require("./en/statCounter.json");
const en_connectorDataParam = require("./en/connectorDataParam.json");
const en_plan = require("./en/plan.json");
const en_role = require("./en/role.json");
const en_auth = require("./en/auth.json");
const en_cabinet = require("./en/cabinet.json");
const en_menu = require("./en/menu.json");
const en_messengerChannel = require("./en/messengerChannel.json");
const en_messengerChat = require("./en/messengerChat.json");
const en_messengerComment = require("./en/messengerComment.json");
const en_messengerContact = require("./en/messengerContact.json");
const en_customer = require("./en/customer.json");
const en_settings = require("./en/settings.json");
const en_sale = require("./en/sale.json");
const en_peerComment = require("./en/peerComment.json");
const en_support = require("./en/support.json");
const en_page = require("./en/page.json");
const en_connectorHandlerParam = require("./en/connectorHandlerParam.json");
const en_compare = require("./en/compare.json");
const en_ai = require("./en/ai.json");
const en_privacy = require("./en/privacy.json");
const en_engagement = require("./en/engagement.json");
const en_currency = require("./en/currency.json");
const en_price = require("./en/price.json");
const en_store = require("./en/store.json");
const en_product = require("./en/product.json");
const en_integration = require("./en/integration.json");
const en_payment = require("./en/payment.json");
const en_delivery = require("./en/delivery.json");
const en_category = require("./en/category.json");
const en_webhook = require("./en/webhook.json");
const en_workflow = require("./en/workflow.json");
const en_error = require("./en/error.json");
const en_orderStatus = require("./en/orderStatus.json");
const en_shortener = require("./en/shortener.json");
const en_task = require("./en/task.json");
const en_device = require("./en/device.json");

const ru_common = require("./ru/common.json");
const ru_project = require("./ru/project.json");
const ru_channel = require("./ru/channel.json");
const ru_connectorHandler = require("./ru/connectorHandler.json");
const ru_connector = require("./ru/connector.json");
const ru_counter = require("./ru/counter.json");
const ru_target = require("./ru/target.json");
const ru_targetStatus = require("./ru/targetStatus.json");
const ru_targetType = require("./ru/targetType.json");
const ru_validator = require("./ru/validator.json");
const ru_user = require("./ru/user.json");
const ru_notification = require("./ru/notification.json");
const ru_notificationStatus = require("./ru/notificationStatus.json");
const ru_wizard = require("./ru/wizard.json");
const ru_search = require("./ru/search.json");
const ru_peerActivity = require("./ru/peerActivity.json");
const ru_comment = require("./ru/comment.json");
const ru_stat = require("./ru/stat.json");
const ru_peerActivityStatus = require("./ru/peerActivityStatus.json");
const ru_eventType = require("./ru/eventType.json");
const ru_peerActivityType = require("./ru/peerActivityType.json");
const ru_peerActivityMode = require("./ru/peerActivityMode.json");
const ru_variantGroup = require("./ru/variantGroup.json");
const ru_recurrentPeriod = require("./ru/recurrentPeriod.json");
const ru_template = require("./ru/template.json");
const ru_quickAnswer = require("./ru/quickAnswer.json");
const ru_statCounter = require("./ru/statCounter.json");
const ru_connectorDataParam = require("./ru/connectorDataParam.json");
const ru_plan = require("./ru/plan.json");
const ru_role = require("./ru/role.json");
const ru_auth = require("./ru/auth.json");
const ru_cabinet = require("./ru/cabinet.json");
const ru_menu = require("./ru/menu.json");
const ru_messengerChannel = require("./ru/messengerChannel.json");
const ru_messengerChat = require("./ru/messengerChat.json");
const ru_messengerComment = require("./ru/messengerComment.json")
const ru_messengerContact = require("./ru/messengerContact.json");
const ru_customer = require("./ru/customer.json");
const ru_settings = require("./ru/settings.json");
const ru_sale = require("./ru/sale.json");
const ru_peerComment = require("./ru/peerComment.json");
const ru_support = require("./ru/support.json");
const ru_page = require("./ru/page.json");
const ru_connectorHandlerParam = require("./ru/connectorHandlerParam.json");
const ru_compare = require("./ru/compare.json");
const ru_ai = require("./ru/ai.json");
const ru_privacy = require("./ru/privacy.json");
const ru_engagement = require("./ru/engagement.json");
const ru_currency = require("./ru/currency.json");
const ru_price = require("./ru/price.json");
const ru_store = require("./ru/store.json");
const ru_product = require("./ru/product.json");
const ru_integration = require("./ru/integration.json");
const ru_payment = require("./ru/payment.json");
const ru_delivery = require("./ru/delivery.json");
const ru_category = require("./ru/category.json");
const ru_webhook = require("./ru/webhook.json");
const ru_workflow = require("./ru/workflow.json");
const ru_error = require("./ru/error.json");
const ru_orderStatus = require("./ru/orderStatus.json");
const ru_shortener = require("./ru/shortener.json");
const ru_task = require("./ru/task.json");
const ru_device = require("./ru/device.json");

const ua_common = require("./ua/common.json");
const ua_project = require("./ua/project.json");
const ua_channel = require("./ua/channel.json");
const ua_connectorHandler = require("./ua/connectorHandler.json");
const ua_connector = require("./ua/connector.json");
const ua_counter = require("./ua/counter.json");
const ua_target = require("./ua/target.json");
const ua_targetStatus = require("./ua/targetStatus.json");
const ua_targetType = require("./ua/targetType.json");
const ua_validator = require("./ua/validator.json");
const ua_user = require("./ua/user.json");
const ua_notification = require("./ua/notification.json");
const ua_notificationStatus = require("./ua/notificationStatus.json");
const ua_wizard = require("./ua/wizard.json");
const ua_search = require("./ua/search.json");
const ua_peerActivity = require("./ua/peerActivity.json");
const ua_comment = require("./ua/comment.json");
const ua_stat = require("./ua/stat.json");
const ua_peerActivityStatus = require("./ua/peerActivityStatus.json");
const ua_eventType = require("./ua/eventType.json");
const ua_peerActivityType = require("./ua/peerActivityType.json");
const ua_peerActivityMode = require("./ua/peerActivityMode.json");
const ua_variantGroup = require("./ua/variantGroup.json");
const ua_recurrentPeriod = require("./ua/recurrentPeriod.json");
const ua_template = require("./ua/template.json");
const ua_quickAnswer = require("./ua/quickAnswer.json");
const ua_statCounter = require("./ua/statCounter.json");
const ua_connectorDataParam = require("./ua/connectorDataParam.json");
const ua_plan = require("./ua/plan.json");
const ua_role = require("./ua/role.json");
const ua_auth = require("./ua/auth.json");
const ua_cabinet = require("./ua/cabinet.json");
const ua_menu = require("./ua/menu.json");
const ua_messengerChannel = require("./ua/messengerChannel.json");
const ua_messengerChat = require("./ua/messengerChat.json");
const ua_messengerComment = require("./ua/messengerComment.json")
const ua_messengerContact = require("./ua/messengerContact.json");
const ua_customer = require("./ua/customer.json");
const ua_settings = require("./ua/settings.json");
const ua_sale = require("./ua/sale.json");
const ua_peerComment = require("./ua/peerComment.json");
const ua_support = require("./ua/support.json");
const ua_page = require("./ua/page.json");
const ua_connectorHandlerParam = require("./ua/connectorHandlerParam.json");
const ua_compare = require("./ua/compare.json");
const ua_ai = require("./ua/ai.json");
const ua_privacy = require("./ua/privacy.json");
const ua_engagement = require("./ua/engagement.json");
const ua_currency = require("./ua/currency.json");
const ua_price = require("./ua/price.json");
const ua_store = require("./ua/store.json");
const ua_product = require("./ua/product.json");
const ua_integration = require("./ua/integration.json");
const ua_payment = require("./ua/payment.json");
const ua_delivery = require("./ua/delivery.json");
const ua_category = require("./ua/category.json");
const ua_webhook = require("./ua/webhook.json");
const ua_workflow = require("./ua/workflow.json");
const ua_error = require("./ua/error.json");
const ua_orderStatus = require("./ua/orderStatus.json");
const ua_shortener = require("./ua/shortener.json");
const ua_task = require("./ua/task.json");
const ua_device = require("./ua/device.json");

const ka_common = require("./ka/common.json");
const ka_project = require("./ka/project.json");
const ka_channel = require("./ka/channel.json");
const ka_connectorHandler = require("./ka/connectorHandler.json");
const ka_connector = require("./ka/connector.json");
const ka_counter = require("./ka/counter.json");
const ka_target = require("./ka/target.json");
const ka_targetStatus = require("./ka/targetStatus.json");
const ka_targetType = require("./ka/targetType.json");
const ka_validator = require("./ka/validator.json");
const ka_user = require("./ka/user.json");
const ka_notification = require("./ka/notification.json");
const ka_notificationStatus = require("./ka/notificationStatus.json");
const ka_wizard = require("./ka/wizard.json");
const ka_search = require("./ka/search.json");
const ka_peerActivity = require("./ka/peerActivity.json");
const ka_comment = require("./ka/comment.json");
const ka_stat = require("./ka/stat.json");
const ka_peerActivityStatus = require("./ka/peerActivityStatus.json");
const ka_eventType = require("./ka/eventType.json");
const ka_peerActivityType = require("./ka/peerActivityType.json");
const ka_peerActivityMode = require("./ka/peerActivityMode.json");
const ka_variantGroup = require("./ka/variantGroup.json");
const ka_recurrentPeriod = require("./ka/recurrentPeriod.json");
const ka_template = require("./ka/template.json");
const ka_quickAnswer = require("./ka/quickAnswer.json");
const ka_statCounter = require("./ka/statCounter.json");
const ka_connectorDataParam = require("./ka/connectorDataParam.json");
const ka_plan = require("./ka/plan.json");
const ka_role = require("./ka/role.json");
const ka_auth = require("./ka/auth.json");
const ka_cabinet = require("./ka/cabinet.json");
const ka_menu = require("./ka/menu.json");
const ka_messengerChannel = require("./ka/messengerChannel.json");
const ka_messengerChat = require("./ka/messengerChat.json");
const ka_messengerComment = require("./ka/messengerComment.json")
const ka_messengerContact = require("./ka/messengerContact.json");
const ka_customer = require("./ka/customer.json");
const ka_settings = require("./ka/settings.json");
const ka_sale = require("./ka/sale.json");
const ka_peerComment = require("./ka/peerComment.json");
const ka_support = require("./ka/support.json");
const ka_page = require("./ka/page.json");
const ka_connectorHandlerParam = require("./ka/connectorHandlerParam.json");
const ka_compare = require("./ka/compare.json");
const ka_ai = require("./ka/ai.json");
const ka_privacy = require("./ka/privacy.json");
const ka_engagement = require("./ka/engagement.json");
const ka_currency = require("./ka/currency.json");
const ka_price = require("./ka/price.json");
const ka_store = require("./ka/store.json");
const ka_product = require("./ka/product.json");
const ka_integration = require("./ka/integration.json");
const ka_payment = require("./ka/payment.json");
const ka_delivery = require("./ka/delivery.json");
const ka_category = require("./ka/category.json");
const ka_webhook = require("./ka/webhook.json");
const ka_workflow = require("./ka/workflow.json");
const ka_error = require("./ka/error.json");
const ka_orderStatus = require("./ka/orderStatus.json");
const ka_shortener = require("./ka/shortener.json");
const ka_task = require("./ka/task.json");
const ka_device = require("./ka/device.json");

const de_common = require("./de/common.json");
const de_project = require("./de/project.json");
const de_channel = require("./de/channel.json");
const de_connectorHandler = require("./de/connectorHandler.json");
const de_connector = require("./de/connector.json");
const de_counter = require("./de/counter.json");
const de_target = require("./de/target.json");
const de_targetStatus = require("./de/targetStatus.json");
const de_targetType = require("./de/targetType.json");
const de_validator = require("./de/validator.json");
const de_user = require("./de/user.json");
const de_notification = require("./de/notification.json");
const de_notificationStatus = require("./de/notificationStatus.json");
const de_wizard = require("./de/wizard.json");
const de_search = require("./de/search.json");
const de_peerActivity = require("./de/peerActivity.json");
const de_comment = require("./de/comment.json");
const de_stat = require("./de/stat.json");
const de_peerActivityStatus = require("./de/peerActivityStatus.json");
const de_eventType = require("./de/eventType.json");
const de_peerActivityType = require("./de/peerActivityType.json");
const de_peerActivityMode = require("./de/peerActivityMode.json");
const de_variantGroup = require("./de/variantGroup.json");
const de_recurrentPeriod = require("./de/recurrentPeriod.json");
const de_template = require("./de/template.json");
const de_quickAnswer = require("./de/quickAnswer.json");
const de_statCounter = require("./de/statCounter.json");
const de_connectorDataParam = require("./de/connectorDataParam.json");
const de_plan = require("./de/plan.json");
const de_role = require("./de/role.json");
const de_auth = require("./de/auth.json");
const de_cabinet = require("./de/cabinet.json");
const de_menu = require("./de/menu.json");
const de_messengerChannel = require("./de/messengerChannel.json");
const de_messengerChat = require("./de/messengerChat.json");
const de_messengerComment = require("./de/messengerComment.json");
const de_messengerContact = require("./de/messengerContact.json");
const de_customer = require("./de/customer.json");
const de_settings = require("./de/settings.json");
const de_sale = require("./de/sale.json");
const de_peerComment = require("./de/peerComment.json");
const de_support = require("./de/support.json");
const de_page = require("./de/page.json");
const de_connectorHandlerParam = require("./de/connectorHandlerParam.json");
const de_compare = require("./de/compare.json");
const de_ai = require("./de/ai.json");
const de_privacy = require("./de/privacy.json");
const de_engagement = require("./de/engagement.json");
const de_currency = require("./de/currency.json");
const de_price = require("./de/price.json");
const de_store = require("./de/store.json");
const de_product = require("./de/product.json");
const de_integration = require("./de/integration.json");
const de_payment = require("./de/payment.json");
const de_delivery = require("./de/delivery.json");
const de_category = require("./de/category.json");
const de_webhook = require("./de/webhook.json");
const de_workflow = require("./de/workflow.json");
const de_error = require("./de/error.json");
const de_orderStatus = require("./de/orderStatus.json");
const de_shortener = require("./de/shortener.json");
const de_task = require("./de/task.json");
const de_device = require("./de/device.json");

const es_common = require("./es/common.json");
const es_project = require("./es/project.json");
const es_channel = require("./es/channel.json");
const es_connectorHandler = require("./es/connectorHandler.json");
const es_connector = require("./es/connector.json");
const es_counter = require("./es/counter.json");
const es_target = require("./es/target.json");
const es_targetStatus = require("./es/targetStatus.json");
const es_targetType = require("./es/targetType.json");
const es_validator = require("./es/validator.json");
const es_user = require("./es/user.json");
const es_notification = require("./es/notification.json");
const es_notificationStatus = require("./es/notificationStatus.json");
const es_wizard = require("./es/wizard.json");
const es_search = require("./es/search.json");
const es_peerActivity = require("./es/peerActivity.json");
const es_comment = require("./es/comment.json");
const es_stat = require("./es/stat.json");
const es_peerActivityStatus = require("./es/peerActivityStatus.json");
const es_eventType = require("./es/eventType.json");
const es_peerActivityType = require("./es/peerActivityType.json");
const es_peerActivityMode = require("./es/peerActivityMode.json");
const es_variantGroup = require("./es/variantGroup.json");
const es_recurrentPeriod = require("./es/recurrentPeriod.json");
const es_template = require("./es/template.json");
const es_quickAnswer = require("./es/quickAnswer.json");
const es_statCounter = require("./es/statCounter.json");
const es_connectorDataParam = require("./es/connectorDataParam.json");
const es_plan = require("./es/plan.json");
const es_role = require("./es/role.json");
const es_auth = require("./es/auth.json");
const es_cabinet = require("./es/cabinet.json");
const es_menu = require("./es/menu.json");
const es_messengerChannel = require("./es/messengerChannel.json");
const es_messengerChat = require("./es/messengerChat.json");
const es_messengerComment = require("./es/messengerComment.json");
const es_messengerContact = require("./es/messengerContact.json");
const es_customer = require("./es/customer.json");
const es_settings = require("./es/settings.json");
const es_sale = require("./es/sale.json");
const es_peerComment = require("./es/peerComment.json");
const es_support = require("./es/support.json");
const es_page = require("./es/page.json");
const es_connectorHandlerParam = require("./es/connectorHandlerParam.json");
const es_compare = require("./es/compare.json");
const es_ai = require("./es/ai.json");
const es_privacy = require("./es/privacy.json");
const es_engagement = require("./es/engagement.json");
const es_currency = require("./es/currency.json");
const es_price = require("./es/price.json");
const es_store = require("./es/store.json");
const es_product = require("./es/product.json");
const es_integration = require("./es/integration.json");
const es_payment = require("./es/payment.json");
const es_delivery = require("./es/delivery.json");
const es_category = require("./es/category.json");
const es_webhook = require("./es/webhook.json");
const es_workflow = require("./es/workflow.json");
const es_error = require("./es/error.json");
const es_orderStatus = require("./es/orderStatus.json");
const es_shortener = require("./es/shortener.json");
const es_task = require("./es/task.json");
const es_device = require("./es/device.json");

const fr_common = require("./fr/common.json");
const fr_project = require("./fr/project.json");
const fr_channel = require("./fr/channel.json");
const fr_connectorHandler = require("./fr/connectorHandler.json");
const fr_connector = require("./fr/connector.json");
const fr_counter = require("./fr/counter.json");
const fr_target = require("./fr/target.json");
const fr_targetStatus = require("./fr/targetStatus.json");
const fr_targetType = require("./fr/targetType.json");
const fr_validator = require("./fr/validator.json");
const fr_user = require("./fr/user.json");
const fr_notification = require("./fr/notification.json");
const fr_notificationStatus = require("./fr/notificationStatus.json");
const fr_wizard = require("./fr/wizard.json");
const fr_search = require("./fr/search.json");
const fr_peerActivity = require("./fr/peerActivity.json");
const fr_comment = require("./fr/comment.json");
const fr_stat = require("./fr/stat.json");
const fr_peerActivityStatus = require("./fr/peerActivityStatus.json");
const fr_eventType = require("./fr/eventType.json");
const fr_peerActivityType = require("./fr/peerActivityType.json");
const fr_peerActivityMode = require("./fr/peerActivityMode.json");
const fr_variantGroup = require("./fr/variantGroup.json");
const fr_recurrentPeriod = require("./fr/recurrentPeriod.json");
const fr_template = require("./fr/template.json");
const fr_quickAnswer = require("./fr/quickAnswer.json");
const fr_statCounter = require("./fr/statCounter.json");
const fr_connectorDataParam = require("./fr/connectorDataParam.json");
const fr_plan = require("./fr/plan.json");
const fr_role = require("./fr/role.json");
const fr_auth = require("./fr/auth.json");
const fr_cabinet = require("./fr/cabinet.json");
const fr_menu = require("./fr/menu.json");
const fr_messengerChannel = require("./fr/messengerChannel.json");
const fr_messengerChat = require("./fr/messengerChat.json");
const fr_messengerComment = require("./fr/messengerComment.json");
const fr_messengerContact = require("./fr/messengerContact.json");
const fr_customer = require("./fr/customer.json");
const fr_settings = require("./fr/settings.json");
const fr_sale = require("./fr/sale.json");
const fr_peerComment = require("./fr/peerComment.json");
const fr_support = require("./fr/support.json");
const fr_page = require("./fr/page.json");
const fr_connectorHandlerParam = require("./fr/connectorHandlerParam.json");
const fr_compare = require("./fr/compare.json");
const fr_ai = require("./fr/ai.json");
const fr_privacy = require("./fr/privacy.json");
const fr_engagement = require("./fr/engagement.json");
const fr_currency = require("./fr/currency.json");
const fr_price = require("./fr/price.json");
const fr_store = require("./fr/store.json");
const fr_product = require("./fr/product.json");
const fr_integration = require("./fr/integration.json");
const fr_payment = require("./fr/payment.json");
const fr_delivery = require("./fr/delivery.json");
const fr_category = require("./fr/category.json");
const fr_webhook = require("./fr/webhook.json");
const fr_workflow = require("./fr/workflow.json");
const fr_error = require("./fr/error.json");
const fr_orderStatus = require("./fr/orderStatus.json");
const fr_shortener = require("./fr/shortener.json");
const fr_task = require("./fr/task.json");
const fr_device = require("./fr/device.json");

const it_common = require("./it/common.json");
const it_project = require("./it/project.json");
const it_channel = require("./it/channel.json");
const it_connectorHandler = require("./it/connectorHandler.json");
const it_connector = require("./it/connector.json");
const it_counter = require("./it/counter.json");
const it_target = require("./it/target.json");
const it_targetStatus = require("./it/targetStatus.json");
const it_targetType = require("./it/targetType.json");
const it_validator = require("./it/validator.json");
const it_user = require("./it/user.json");
const it_notification = require("./it/notification.json");
const it_notificationStatus = require("./it/notificationStatus.json");
const it_wizard = require("./it/wizard.json");
const it_search = require("./it/search.json");
const it_peerActivity = require("./it/peerActivity.json");
const it_comment = require("./it/comment.json");
const it_stat = require("./it/stat.json");
const it_peerActivityStatus = require("./it/peerActivityStatus.json");
const it_eventType = require("./it/eventType.json");
const it_peerActivityType = require("./it/peerActivityType.json");
const it_peerActivityMode = require("./it/peerActivityMode.json");
const it_variantGroup = require("./it/variantGroup.json");
const it_recurrentPeriod = require("./it/recurrentPeriod.json");
const it_template = require("./it/template.json");
const it_quickAnswer = require("./it/quickAnswer.json");
const it_statCounter = require("./it/statCounter.json");
const it_connectorDataParam = require("./it/connectorDataParam.json");
const it_plan = require("./it/plan.json");
const it_role = require("./it/role.json");
const it_auth = require("./it/auth.json");
const it_cabinet = require("./it/cabinet.json");
const it_menu = require("./it/menu.json");
const it_messengerChannel = require("./it/messengerChannel.json");
const it_messengerChat = require("./it/messengerChat.json");
const it_messengerComment = require("./it/messengerComment.json");
const it_messengerContact = require("./it/messengerContact.json");
const it_customer = require("./it/customer.json");
const it_settings = require("./it/settings.json");
const it_sale = require("./it/sale.json");
const it_peerComment = require("./it/peerComment.json");
const it_support = require("./it/support.json");
const it_page = require("./it/page.json");
const it_connectorHandlerParam = require("./it/connectorHandlerParam.json");
const it_compare = require("./it/compare.json");
const it_ai = require("./it/ai.json");
const it_privacy = require("./it/privacy.json");
const it_engagement = require("./it/engagement.json");
const it_currency = require("./it/currency.json");
const it_price = require("./it/price.json");
const it_store = require("./it/store.json");
const it_product = require("./it/product.json");
const it_integration = require("./it/integration.json");
const it_payment = require("./it/payment.json");
const it_delivery = require("./it/delivery.json");
const it_category = require("./it/category.json");
const it_webhook = require("./it/webhook.json");
const it_workflow = require("./it/workflow.json");
const it_error = require("./it/error.json");
const it_orderStatus = require("./it/orderStatus.json");
const it_shortener = require("./it/shortener.json");
const it_task = require("./it/task.json");
const it_device = require("./it/device.json");

const pl_common = require("./pl/common.json");
const pl_project = require("./pl/project.json");
const pl_channel = require("./pl/channel.json");
const pl_connectorHandler = require("./pl/connectorHandler.json");
const pl_connector = require("./pl/connector.json");
const pl_counter = require("./pl/counter.json");
const pl_target = require("./pl/target.json");
const pl_targetStatus = require("./pl/targetStatus.json");
const pl_targetType = require("./pl/targetType.json");
const pl_validator = require("./pl/validator.json");
const pl_user = require("./pl/user.json");
const pl_notification = require("./pl/notification.json");
const pl_notificationStatus = require("./pl/notificationStatus.json");
const pl_wizard = require("./pl/wizard.json");
const pl_search = require("./pl/search.json");
const pl_peerActivity = require("./pl/peerActivity.json");
const pl_comment = require("./pl/comment.json");
const pl_stat = require("./pl/stat.json");
const pl_peerActivityStatus = require("./pl/peerActivityStatus.json");
const pl_eventType = require("./pl/eventType.json");
const pl_peerActivityType = require("./pl/peerActivityType.json");
const pl_peerActivityMode = require("./pl/peerActivityMode.json");
const pl_variantGroup = require("./pl/variantGroup.json");
const pl_recurrentPeriod = require("./pl/recurrentPeriod.json");
const pl_template = require("./pl/template.json");
const pl_quickAnswer = require("./pl/quickAnswer.json");
const pl_statCounter = require("./pl/statCounter.json");
const pl_connectorDataParam = require("./pl/connectorDataParam.json");
const pl_plan = require("./pl/plan.json");
const pl_role = require("./pl/role.json");
const pl_auth = require("./pl/auth.json");
const pl_cabinet = require("./pl/cabinet.json");
const pl_menu = require("./pl/menu.json");
const pl_messengerChannel = require("./pl/messengerChannel.json");
const pl_messengerChat = require("./pl/messengerChat.json");
const pl_messengerComment = require("./pl/messengerComment.json");
const pl_messengerContact = require("./pl/messengerContact.json");
const pl_customer = require("./pl/customer.json");
const pl_settings = require("./pl/settings.json");
const pl_sale = require("./pl/sale.json");
const pl_peerComment = require("./pl/peerComment.json");
const pl_support = require("./pl/support.json");
const pl_page = require("./pl/page.json");
const pl_connectorHandlerParam = require("./pl/connectorHandlerParam.json");
const pl_compare = require("./pl/compare.json");
const pl_ai = require("./pl/ai.json");
const pl_privacy = require("./pl/privacy.json");
const pl_engagement = require("./pl/engagement.json");
const pl_currency = require("./pl/currency.json");
const pl_price = require("./pl/price.json");
const pl_store = require("./pl/store.json");
const pl_product = require("./pl/product.json");
const pl_integration = require("./pl/integration.json");
const pl_payment = require("./pl/payment.json");
const pl_delivery = require("./pl/delivery.json");
const pl_category = require("./pl/category.json");
const pl_webhook = require("./pl/webhook.json");
const pl_workflow = require("./pl/workflow.json");
const pl_error = require("./pl/error.json");
const pl_orderStatus = require("./pl/orderStatus.json");
const pl_shortener = require("./pl/shortener.json");
const pl_task = require("./pl/task.json");
const pl_device = require("./pl/device.json");

const pt_common = require("./pt/common.json");
const pt_project = require("./pt/project.json");
const pt_channel = require("./pt/channel.json");
const pt_connectorHandler = require("./pt/connectorHandler.json");
const pt_connector = require("./pt/connector.json");
const pt_counter = require("./pt/counter.json");
const pt_target = require("./pt/target.json");
const pt_targetStatus = require("./pt/targetStatus.json");
const pt_targetType = require("./pt/targetType.json");
const pt_validator = require("./pt/validator.json");
const pt_user = require("./pt/user.json");
const pt_notification = require("./pt/notification.json");
const pt_notificationStatus = require("./pt/notificationStatus.json");
const pt_wizard = require("./pt/wizard.json");
const pt_search = require("./pt/search.json");
const pt_peerActivity = require("./pt/peerActivity.json");
const pt_comment = require("./pt/comment.json");
const pt_stat = require("./pt/stat.json");
const pt_peerActivityStatus = require("./pt/peerActivityStatus.json");
const pt_eventType = require("./pt/eventType.json");
const pt_peerActivityType = require("./pt/peerActivityType.json");
const pt_peerActivityMode = require("./pt/peerActivityMode.json");
const pt_variantGroup = require("./pt/variantGroup.json");
const pt_recurrentPeriod = require("./pt/recurrentPeriod.json");
const pt_template = require("./pt/template.json");
const pt_quickAnswer = require("./pt/quickAnswer.json");
const pt_statCounter = require("./pt/statCounter.json");
const pt_connectorDataParam = require("./pt/connectorDataParam.json");
const pt_plan = require("./pt/plan.json");
const pt_role = require("./pt/role.json");
const pt_auth = require("./pt/auth.json");
const pt_cabinet = require("./pt/cabinet.json");
const pt_menu = require("./pt/menu.json");
const pt_messengerChannel = require("./pt/messengerChannel.json");
const pt_messengerChat = require("./pt/messengerChat.json");
const pt_messengerComment = require("./pt/messengerComment.json");
const pt_messengerContact = require("./pt/messengerContact.json");
const pt_customer = require("./pt/customer.json");
const pt_settings = require("./pt/settings.json");
const pt_sale = require("./pt/sale.json");
const pt_peerComment = require("./pt/peerComment.json");
const pt_support = require("./pt/support.json");
const pt_page = require("./pt/page.json");
const pt_connectorHandlerParam = require("./pt/connectorHandlerParam.json");
const pt_compare = require("./pt/compare.json");
const pt_ai = require("./pt/ai.json");
const pt_privacy = require("./pt/privacy.json");
const pt_engagement = require("./pt/engagement.json");
const pt_currency = require("./pt/currency.json");
const pt_price = require("./pt/price.json");
const pt_store = require("./pt/store.json");
const pt_product = require("./pt/product.json");
const pt_integration = require("./pt/integration.json");
const pt_payment = require("./pt/payment.json");
const pt_delivery = require("./pt/delivery.json");
const pt_category = require("./pt/category.json");
const pt_webhook = require("./pt/webhook.json");
const pt_workflow = require("./pt/workflow.json");
const pt_error = require("./pt/error.json");
const pt_orderStatus = require("./pt/orderStatus.json");
const pt_shortener = require("./pt/shortener.json");
const pt_task = require("./pt/task.json");
const pt_device = require("./pt/device.json");

const tr_common = require("./tr/common.json");
const tr_project = require("./tr/project.json");
const tr_channel = require("./tr/channel.json");
const tr_connectorHandler = require("./tr/connectorHandler.json");
const tr_connector = require("./tr/connector.json");
const tr_counter = require("./tr/counter.json");
const tr_target = require("./tr/target.json");
const tr_targetStatus = require("./tr/targetStatus.json");
const tr_targetType = require("./tr/targetType.json");
const tr_validator = require("./tr/validator.json");
const tr_user = require("./tr/user.json");
const tr_notification = require("./tr/notification.json");
const tr_notificationStatus = require("./tr/notificationStatus.json");
const tr_wizard = require("./tr/wizard.json");
const tr_search = require("./tr/search.json");
const tr_peerActivity = require("./tr/peerActivity.json");
const tr_comment = require("./tr/comment.json");
const tr_stat = require("./tr/stat.json");
const tr_peerActivityStatus = require("./tr/peerActivityStatus.json");
const tr_eventType = require("./tr/eventType.json");
const tr_peerActivityType = require("./tr/peerActivityType.json");
const tr_peerActivityMode = require("./tr/peerActivityMode.json");
const tr_variantGroup = require("./tr/variantGroup.json");
const tr_recurrentPeriod = require("./tr/recurrentPeriod.json");
const tr_template = require("./tr/template.json");
const tr_quickAnswer = require("./tr/quickAnswer.json");
const tr_statCounter = require("./tr/statCounter.json");
const tr_connectorDataParam = require("./tr/connectorDataParam.json");
const tr_plan = require("./tr/plan.json");
const tr_role = require("./tr/role.json");
const tr_auth = require("./tr/auth.json");
const tr_cabinet = require("./tr/cabinet.json");
const tr_menu = require("./tr/menu.json");
const tr_messengerChannel = require("./tr/messengerChannel.json");
const tr_messengerChat = require("./tr/messengerChat.json");
const tr_messengerComment = require("./tr/messengerComment.json");
const tr_messengerContact = require("./tr/messengerContact.json");
const tr_customer = require("./tr/customer.json");
const tr_settings = require("./tr/settings.json");
const tr_sale = require("./tr/sale.json");
const tr_peerComment = require("./tr/peerComment.json");
const tr_support = require("./tr/support.json");
const tr_page = require("./tr/page.json");
const tr_connectorHandlerParam = require("./tr/connectorHandlerParam.json");
const tr_compare = require("./tr/compare.json");
const tr_ai = require("./tr/ai.json");
const tr_privacy = require("./tr/privacy.json");
const tr_engagement = require("./tr/engagement.json");
const tr_currency = require("./tr/currency.json");
const tr_price = require("./tr/price.json");
const tr_store = require("./tr/store.json");
const tr_product = require("./tr/product.json");
const tr_integration = require("./tr/integration.json");
const tr_payment = require("./tr/payment.json");
const tr_delivery = require("./tr/delivery.json");
const tr_category = require("./tr/category.json");
const tr_webhook = require("./tr/webhook.json");
const tr_workflow = require("./tr/workflow.json");
const tr_error = require("./tr/error.json");
const tr_orderStatus = require("./tr/orderStatus.json");
const tr_shortener = require("./tr/shortener.json");
const tr_task = require("./tr/task.json");
const tr_device = require("./tr/device.json");

export const resources = {
    de: {
        auth: de_auth,
        common: de_common,
        cabinet: de_cabinet,
        validator: de_validator,
        project: de_project,
        channel: de_channel,
        connectorHandler: de_connectorHandler,
        connector: de_connector,
        counter: de_counter,
        target: de_target,
        user: de_user,
        notification: de_notification,
        wizard: de_wizard,
        search: de_search,
        peerActivity: de_peerActivity,
        comment: de_comment,
        stat: de_stat,
        peerActivityStatus: de_peerActivityStatus,
        eventType: de_eventType,
        error: de_error,
        peerActivityType:de_peerActivityType,
        notificationStatus:de_notificationStatus,
        recurrentPeriod:de_recurrentPeriod,
        targetStatus:de_targetStatus,
        targetType:de_targetType,
        peerActivityMode:de_peerActivityMode,
        variantGroup:de_variantGroup,
        template:de_template,
        quickAnswer:de_quickAnswer,
        statCounter: de_statCounter,
        connectorDataParam:de_connectorDataParam,
        plan:de_plan,
        role:de_role,
        menu:de_menu,
        messengerChannel: de_messengerChannel,
        messengerChat: de_messengerChat,
        messengerComment: de_messengerComment,
        messengerContact: de_messengerContact,
        customer: de_customer,
        settings: de_settings,
        sale: de_sale,
        peerComment: de_peerComment,
        support: de_support,
        page:de_page,
        connectorHandlerParam: de_connectorHandlerParam,
        compare: de_compare,
        ai: de_ai,
        privacy: de_privacy,
        engagement: de_engagement,
        currency: de_currency,
        price:de_price,
        store: de_store,
        product: de_product,
        integration: de_integration,
        payment: de_payment,
        delivery: de_delivery,
        category: de_category,
        webhook: de_webhook,
        orderStatus: de_orderStatus,
        shortener: de_shortener,
        task: de_task,
        device: de_device,
        workflow: de_workflow
    },
    es: {
        auth: es_auth,
        common: es_common,
        cabinet: es_cabinet,
        validator: es_validator,
        project: es_project,
        channel: es_channel,
        connectorHandler: es_connectorHandler,
        connector: es_connector,
        counter: es_counter,
        target: es_target,
        user: es_user,
        notification: es_notification,
        wizard: es_wizard,
        search: es_search,
        peerActivity: es_peerActivity,
        comment: es_comment,
        stat: es_stat,
        peerActivityStatus: es_peerActivityStatus,
        eventType: es_eventType,
        error: es_error,
        peerActivityType:es_peerActivityType,
        notificationStatus:es_notificationStatus,
        recurrentPeriod:es_recurrentPeriod,
        targetStatus:es_targetStatus,
        targetType:es_targetType,
        peerActivityMode:es_peerActivityMode,
        variantGroup:es_variantGroup,
        template:es_template,
        quickAnswer:es_quickAnswer,
        statCounter: es_statCounter,
        connectorDataParam:es_connectorDataParam,
        plan:es_plan,
        role:es_role,
        menu:es_menu,
        messengerChannel: es_messengerChannel,
        messengerChat: es_messengerChat,
        messengerComment: es_messengerComment,
        messengerContact: es_messengerContact,
        customer: es_customer,
        settings: es_settings,
        sale: es_sale,
        peerComment: es_peerComment,
        support: es_support,
        page:es_page,
        connectorHandlerParam: es_connectorHandlerParam,
        compare: es_compare,
        ai: es_ai,
        privacy: es_privacy,
        engagement: es_engagement,
        currency: es_currency,
        price:es_price,
        store: es_store,
        product: es_product,
        integration: es_integration,
        payment: es_payment,
        delivery: es_delivery,
        category: es_category,
        webhook: es_webhook,
        orderStatus: es_orderStatus,
        shortener: es_shortener,
        task: es_task,
        device: es_device,
        workflow: es_workflow
    },
    fr: {
        auth: fr_auth,
        common: fr_common,
        cabinet: fr_cabinet,
        validator: fr_validator,
        project: fr_project,
        channel: fr_channel,
        connectorHandler: fr_connectorHandler,
        connector: fr_connector,
        counter: fr_counter,
        target: fr_target,
        user: fr_user,
        notification: fr_notification,
        wizard: fr_wizard,
        search: fr_search,
        peerActivity: fr_peerActivity,
        comment: fr_comment,
        stat: fr_stat,
        peerActivityStatus: fr_peerActivityStatus,
        eventType: fr_eventType,
        error: fr_error,
        peerActivityType:fr_peerActivityType,
        notificationStatus:fr_notificationStatus,
        recurrentPeriod:fr_recurrentPeriod,
        targetStatus:fr_targetStatus,
        targetType:fr_targetType,
        peerActivityMode:fr_peerActivityMode,
        variantGroup:fr_variantGroup,
        template:fr_template,
        quickAnswer:fr_quickAnswer,
        statCounter: fr_statCounter,
        connectorDataParam:fr_connectorDataParam,
        plan:fr_plan,
        role:fr_role,
        menu:fr_menu,
        messengerChannel: fr_messengerChannel,
        messengerChat: fr_messengerChat,
        messengerComment: fr_messengerComment,
        messengerContact: fr_messengerContact,
        customer: fr_customer,
        settings: fr_settings,
        sale: fr_sale,
        peerComment: fr_peerComment,
        support: fr_support,
        page:fr_page,
        connectorHandlerParam: fr_connectorHandlerParam,
        compare: fr_compare,
        ai: fr_ai,
        privacy: fr_privacy,
        engagement: fr_engagement,
        currency: fr_currency,
        price:fr_price,
        store: fr_store,
        product: fr_product,
        integration: fr_integration,
        payment: fr_payment,
        delivery: fr_delivery,
        category: fr_category,
        webhook: fr_webhook,
        orderStatus: fr_orderStatus,
        shortener: fr_shortener,
        task: fr_task,
        device: fr_device,
        workflow: fr_workflow
    },
    it: {
        auth: it_auth,
        common: it_common,
        cabinet: it_cabinet,
        validator: it_validator,
        project: it_project,
        channel: it_channel,
        connectorHandler: it_connectorHandler,
        connector: it_connector,
        counter: it_counter,
        target: it_target,
        user: it_user,
        notification: it_notification,
        wizard: it_wizard,
        search: it_search,
        peerActivity: it_peerActivity,
        comment: it_comment,
        stat: it_stat,
        peerActivityStatus: it_peerActivityStatus,
        eventType: it_eventType,
        error: it_error,
        peerActivityType:it_peerActivityType,
        notificationStatus:it_notificationStatus,
        recurrentPeriod:it_recurrentPeriod,
        targetStatus:it_targetStatus,
        targetType:it_targetType,
        peerActivityMode:it_peerActivityMode,
        variantGroup:it_variantGroup,
        template:it_template,
        quickAnswer:it_quickAnswer,
        statCounter: it_statCounter,
        connectorDataParam:it_connectorDataParam,
        plan:it_plan,
        role:it_role,
        menu:it_menu,
        messengerChannel: it_messengerChannel,
        messengerChat: it_messengerChat,
        messengerComment: it_messengerComment,
        messengerContact: it_messengerContact,
        customer: it_customer,
        settings: it_settings,
        sale: it_sale,
        peerComment: it_peerComment,
        support: it_support,
        page:it_page,
        connectorHandlerParam: it_connectorHandlerParam,
        compare: it_compare,
        ai: it_ai,
        privacy: it_privacy,
        engagement: it_engagement,
        currency: it_currency,
        price:it_price,
        store: it_store,
        product: it_product,
        integration: it_integration,
        payment: it_payment,
        delivery: it_delivery,
        category: it_category,
        webhook: it_webhook,
        orderStatus: it_orderStatus,
        shortener: it_shortener,
        task: it_task,
        device: it_device,
        workflow: it_workflow

    
    },
    pl: {
        auth: pl_auth,
        common: pl_common,
        cabinet: pl_cabinet,
        validator: pl_validator,
        project: pl_project,
        channel: pl_channel,
        connectorHandler: pl_connectorHandler,
        connector: pl_connector,
        counter: pl_counter,
        target: pl_target,
        user: pl_user,
        notification: pl_notification,
        wizard: pl_wizard,
        search: pl_search,
        peerActivity: pl_peerActivity,
        comment: pl_comment,
        stat: pl_stat,
        peerActivityStatus: pl_peerActivityStatus,
        eventType: pl_eventType,
        error: pl_error,
        peerActivityType:pl_peerActivityType,
        notificationStatus:pl_notificationStatus,
        recurrentPeriod:pl_recurrentPeriod,
        targetStatus:pl_targetStatus,
        targetType:pl_targetType,
        peerActivityMode:pl_peerActivityMode,
        variantGroup:pl_variantGroup,
        template:pl_template,
        quickAnswer:pl_quickAnswer,
        statCounter: pl_statCounter,
        connectorDataParam:pl_connectorDataParam,
        plan:pl_plan,
        role:pl_role,
        menu:pl_menu,
        messengerChannel: pl_messengerChannel,
        messengerChat: pl_messengerChat,
        messengerComment: pl_messengerComment,
        messengerContact: pl_messengerContact,
        customer: pl_customer,
        settings: pl_settings,
        sale: pl_sale,
        peerComment: pl_peerComment,
        support: pl_support,
        page:pl_page,
        connectorHandlerParam: pl_connectorHandlerParam,
        compare: pl_compare,
        ai: pl_ai,
        privacy: pl_privacy,
        engagement: pl_engagement,
        currency: pl_currency,
        price:pl_price,
        store: pl_store,
        product: pl_product,
        integration: pl_integration,
        payment: pl_payment,
        delivery: pl_delivery,
        category: pl_category,
        webhook: pl_webhook,
        orderStatus: pl_orderStatus,
        shortener: pl_shortener,
        task: pl_task,
        device: pl_device,
        workflow: pl_workflow

    
    },
    pt: {
        auth: pt_auth,
        common: pt_common,
        cabinet: pt_cabinet,
        validator: pt_validator,
        project: pt_project,
        channel: pt_channel,
        connectorHandler: pt_connectorHandler,
        connector: pt_connector,
        counter: pt_counter,
        target: pt_target,
        user: pt_user,
        notification: pt_notification,
        wizard: pt_wizard,
        search: pt_search,
        peerActivity: pt_peerActivity,
        comment: pt_comment,
        stat: pt_stat,
        peerActivityStatus: pt_peerActivityStatus,
        eventType: pt_eventType,
        error: pt_error,
        peerActivityType:pt_peerActivityType,
        notificationStatus:pt_notificationStatus,
        recurrentPeriod:pt_recurrentPeriod,
        targetStatus:pt_targetStatus,
        targetType:pt_targetType,
        peerActivityMode:pt_peerActivityMode,
        variantGroup:pt_variantGroup,
        template:pt_template,
        quickAnswer:pt_quickAnswer,
        statCounter: pt_statCounter,
        connectorDataParam:pt_connectorDataParam,
        plan:pt_plan,
        role:pt_role,
        menu:pt_menu,
        messengerChannel: pt_messengerChannel,
        messengerChat: pt_messengerChat,
        messengerComment: pt_messengerComment,
        messengerContact: pt_messengerContact,
        customer: pt_customer,
        settings: pt_settings,
        sale: pt_sale,
        peerComment: pt_peerComment,
        support: pt_support,
        page:pt_page,
        connectorHandlerParam: pt_connectorHandlerParam,
        compare: pt_compare,
        ai: pt_ai,
        privacy: pt_privacy,
        engagement: pt_engagement,
        currency: pt_currency,
        price:pt_price,
        store: pt_store,
        product: pt_product,
        integration: pt_integration,
        payment: pt_payment,
        delivery: pt_delivery,
        category: pt_category,
        webhook: pt_webhook,
        orderStatus: pt_orderStatus,
        shortener: pt_shortener,
        task: pt_task,
        device: pt_device,
        workflow: pt_workflow

    
    },
    tr: {
        auth: tr_auth,
        common: tr_common,
        cabinet: tr_cabinet,
        validator: tr_validator,
        project: tr_project,
        channel: tr_channel,
        connectorHandler: tr_connectorHandler,
        connector: tr_connector,
        counter: tr_counter,
        target: tr_target,
        user: tr_user,
        notification: tr_notification,
        wizard: tr_wizard,
        search: tr_search,
        peerActivity: tr_peerActivity,
        comment: tr_comment,
        stat: tr_stat,
        peerActivityStatus: tr_peerActivityStatus,
        eventType: tr_eventType,
        error: tr_error,
        peerActivityType:tr_peerActivityType,
        notificationStatus:tr_notificationStatus,
        recurrentPeriod:tr_recurrentPeriod,
        targetStatus:tr_targetStatus,
        targetType:tr_targetType,
        peerActivityMode:tr_peerActivityMode,
        variantGroup:tr_variantGroup,
        template:tr_template,
        quickAnswer:tr_quickAnswer,
        statCounter: tr_statCounter,
        connectorDataParam:tr_connectorDataParam,
        plan:tr_plan,
        role:tr_role,
        menu:tr_menu,
        messengerChannel: tr_messengerChannel,
        messengerChat: tr_messengerChat,
        messengerComment: tr_messengerComment,
        messengerContact: tr_messengerContact,
        customer: tr_customer,
        settings: tr_settings,
        sale: tr_sale,
        peerComment: tr_peerComment,
        support: tr_support,
        page:tr_page,
        connectorHandlerParam: tr_connectorHandlerParam,
        compare: tr_compare,
        ai: tr_ai,
        privacy: tr_privacy,
        engagement: tr_engagement,
        currency: tr_currency,
        price:tr_price,
        store: tr_store,
        product: tr_product,
        integration: tr_integration,
        payment: tr_payment,
        delivery: tr_delivery,
        category: tr_category,
        webhook: tr_webhook,
        orderStatus: tr_orderStatus,
        shortener: tr_shortener,
        task: tr_task,
        device: tr_device,
        workflow: tr_workflow

    
    },
    en: {
        auth: en_auth,
        common: en_common,
        cabinet: en_cabinet,
        validator: en_validator,
        project: en_project,
        channel: en_channel,
        connectorHandler: en_connectorHandler,
        connector: en_connector,
        counter: en_counter,
        target: en_target,
        user: en_user,
        notification: en_notification,
        wizard: en_wizard,
        search: en_search,
        peerActivity: en_peerActivity,
        comment: en_comment,
        stat: en_stat,
        peerActivityStatus: en_peerActivityStatus,
        eventType: en_eventType,
        error: en_error,
        peerActivityType:en_peerActivityType,
        notificationStatus:en_notificationStatus,
        recurrentPeriod:en_recurrentPeriod,
        targetStatus:en_targetStatus,
        targetType:en_targetType,
        peerActivityMode:en_peerActivityMode,
        variantGroup:en_variantGroup,
        template:en_template,
        quickAnswer:en_quickAnswer,
        statCounter: en_statCounter,
        connectorDataParam:en_connectorDataParam,
        plan:en_plan,
        role:en_role,
        menu:en_menu,
        messengerChannel: en_messengerChannel,
        messengerChat: en_messengerChat,
        messengerComment: en_messengerComment,
        messengerContact: en_messengerContact,
        customer: en_customer,
        settings: en_settings,
        sale: en_sale,
        peerComment: en_peerComment,
        support: en_support,
        page:en_page,
        connectorHandlerParam: en_connectorHandlerParam,
        compare: en_compare,
        ai: en_ai,
        privacy: en_privacy,
        engagement: en_engagement,
        currency: en_currency,
        price:en_price,
        store: en_store,
        product: en_product,
        integration: en_integration,
        payment: en_payment,
        delivery: en_delivery,
        category: en_category,
        webhook: en_webhook,
        orderStatus: en_orderStatus,
        shortener: en_shortener,
        task: en_task,
        device: en_device,
        workflow: en_workflow

    },
    ru: {
        auth: ru_auth,
        common: ru_common,
        cabinet: ru_cabinet,
        validator: ru_validator,
        project: ru_project,
        channel: ru_channel,
        connectorHandler: ru_connectorHandler,
        connector: ru_connector,
        counter: ru_counter,
        target: ru_target,
        user: ru_user,
        notification: ru_notification,
        wizard: ru_wizard,
        search: ru_search,
        peerActivity: ru_peerActivity,
        comment: ru_comment,
        stat: ru_stat,
        peerActivityStatus: ru_peerActivityStatus,
        eventType: ru_eventType,
        error: ru_error,
        peerActivityType:ru_peerActivityType,
        notificationStatus:ru_notificationStatus,
        recurrentPeriod:ru_recurrentPeriod,
        targetStatus:ru_targetStatus,
        targetType:ru_targetType,
        peerActivityMode:ru_peerActivityMode,
        variantGroup:ru_variantGroup,
        template:ru_template,
        quickAnswer:ru_quickAnswer,
        statCounter: ru_statCounter,
        connectorDataParam:ru_connectorDataParam,
        plan:ru_plan,
        role:ru_role,
        menu:ru_menu,
        messengerChannel: ru_messengerChannel,
        messengerChat: ru_messengerChat,
        messengerComment: ru_messengerComment,
        messengerContact: ru_messengerContact,
        customer: ru_customer,
        settings: ru_settings,
        sale: ru_sale,
        peerComment: ru_peerComment,
        support: ru_support,
        page:ru_page,
        connectorHandlerParam: ru_connectorHandlerParam,
        compare: ru_compare,
        ai: ru_ai,
        privacy: ru_privacy,
        engagement: ru_engagement,
        currency: ru_currency,
        price: ru_price,
        store: ru_store,
        product: ru_product,
        integration: ru_integration,
        payment: ru_payment,
        delivery: ru_delivery,
        category: ru_category,
        webhook: ru_webhook,
        orderStatus: ru_orderStatus,
        shortener: ru_shortener,
        task: ru_task,
        device: ru_device,
        workflow: ru_workflow
    },
    ua:{
        auth: ua_auth,
        common: ua_common,
        cabinet: ua_cabinet,
        validator: ua_validator,
        project: ua_project,
        channel: ua_channel,
        connectorHandler: ua_connectorHandler,
        connector: ua_connector,
        counter: ua_counter,
        target: ua_target,
        user: ua_user,
        notification: ua_notification,
        wizard: ua_wizard,
        search: ua_search,
        peerActivity: ua_peerActivity,
        comment: ua_comment,
        stat: ua_stat,
        peerActivityStatus: ua_peerActivityStatus,
        eventType: ua_eventType,
        error: ua_error,
        peerActivityType:ua_peerActivityType,
        notificationStatus:ua_notificationStatus,
        recurrentPeriod:ua_recurrentPeriod,
        targetStatus:ua_targetStatus,
        targetType:ua_targetType,
        peerActivityMode:ua_peerActivityMode,
        variantGroup:ua_variantGroup,
        template:ua_template,
        quickAnswer:ua_quickAnswer,
        statCounter: ua_statCounter,
        connectorDataParam:ua_connectorDataParam,
        plan:ua_plan,
        role:ua_role,
        menu:ua_menu,
        messengerChannel: ua_messengerChannel,
        messengerChat: ua_messengerChat,
        messengerComment: ua_messengerComment,
        messengerContact: ua_messengerContact,
        customer: ua_customer,
        settings: ua_settings,
        sale: ua_sale,
        peerComment: ua_peerComment,
        support: ua_support,
        page:ua_page,
        connectorHandlerParam: ua_connectorHandlerParam,
        compare: ua_compare,
        ai: ua_ai,
        privacy: ua_privacy,
        engagement: ua_engagement,
        currency: ua_currency,
        price: ua_price,
        store: ua_store,
        product: ua_product,
        integration: ua_integration,
        payment: ua_payment,
        delivery: ua_delivery,
        category: ua_category,
        webhook: ua_webhook,
        orderStatus: ua_orderStatus,
        shortener: ua_shortener,
        task: ua_task,
        device: ua_device,
        workflow: ua_workflow

    },
    ka:{
        auth: ka_auth,
        common: ka_common,
        cabinet: ka_cabinet,
        validator: ka_validator,
        project: ka_project,
        channel: ka_channel,
        connectorHandler: ka_connectorHandler,
        connector: ka_connector,
        counter: ka_counter,
        target: ka_target,
        user: ka_user,
        notification: ka_notification,
        wizard: ka_wizard,
        search: ka_search,
        peerActivity: ka_peerActivity,
        comment: ka_comment,
        stat: ka_stat,
        peerActivityStatus: ka_peerActivityStatus,
        eventType: ka_eventType,
        error: ka_error,
        peerActivityType:ka_peerActivityType,
        notificationStatus:ka_notificationStatus,
        recurrentPeriod:ka_recurrentPeriod,
        targetStatus:ka_targetStatus,
        targetType:ka_targetType,
        peerActivityMode:ka_peerActivityMode,
        variantGroup:ka_variantGroup,
        template:ka_template,
        quickAnswer:ka_quickAnswer,
        statCounter: ka_statCounter,
        connectorDataParam:ka_connectorDataParam,
        plan:ka_plan,
        role:ka_role,
        menu:ka_menu,
        messengerChannel: ka_messengerChannel,
        messengerChat: ka_messengerChat,
        messengerComment: ka_messengerComment,
        messengerContact: ka_messengerContact,
        customer: ka_customer,
        settings: ka_settings,
        sale: ka_sale,
        peerComment: ka_peerComment,
        support: ka_support,
        page:ka_page,
        connectorHandlerParam: ka_connectorHandlerParam,
        compare: ka_compare,
        ai: ka_ai,
        privacy: ka_privacy,
        engagement: ka_engagement,
        currency: ka_currency,
        price: ka_price,
        store: ka_store,
        product: ka_product,
        integration: ka_integration,
        payment: ka_payment,
        delivery: ka_delivery,
        category: ka_category,
        webhook: ka_webhook,
        orderStatus: ka_orderStatus,
        shortener: ka_shortener,
        task: ka_task,
        device: ka_device,
        workflow: ka_workflow

    }
} as const;

const language = getCurrentLanguage();

i18next.use(initReactI18next).init({
    lng: language || "en",
    fallbackLng: "en",
    ns: [
        'common',
        'cabinet',
        'project',
        'validator',
        'channel',
        'connectorHandler',
        'connector',
        'counter',
        'target',
        'user',
        'notification',
        'wizard',
        'search',
        'peerActivity',
        'comment',
        'stat',
        'peerActivityStatus',
        'eventType',
        'peerActivityType',
        'notificationStatus',
        'recurrentPeriod',
        'targetStatus',
        'targetType',
        'peerActivityMode',
        'variantGroup',
        'template',
        'statCounter',
        'connectorDataParam',
        'plan',
        'role',
        'auth',
        'menu',
        'messengerChannel',
        'messengerChat',
        'messengerComment',
        'messengerContact',
        'customer',
        'settings',
        'sale',
        'peerComment',
        'support',
        'page',
        'connectorHandlerParam',
        'compare',
        'ai',
        'privacy',
        'engagement',
        'currency',
        'price',
        'store',
        'product',
        'integration',
        'payment',
        'delivery',
        'category',
        'webhook',
        'orderStatus',
        'shortener',
        'task',
        'device',
        'workflow',
        'error'
    ],
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
});